import './cookiebar.scss'
import { useLocalStorage } from 'app-logic/storage'
import { useEffect, useState } from 'react'

export const CookieBar: React.FC = () => {
  const [cookieAccepted, setCookiesAccepted] = useLocalStorage<boolean>('CookiesAccepted', false)
  const [accepted, setAccepted] = useState(cookieAccepted)

  const onScroll = () => {
    //hide it one the user has scrolled at least one page
    if (window.scrollY > window.innerHeight && !accepted) {
      onAcceptClick()
    }
  }
  useEffect(() => {
    window.addEventListener('scroll', onScroll)
    return () => {
      window.removeEventListener('scroll', onScroll)
    }
  })

  const onAcceptClick = () => {
    setAccepted?.(true)
    window.removeEventListener('scroll', onScroll)
    setCookiesAccepted(true)
  }


  return (
    <>
      {
        !cookieAccepted && (
          <div className="cookie-bar d-flex align-items-center w-100 p-3">
            <div className="flex-grow-1 pr-4">
              This site uses <a href="https://cookiesandyou.com/" target="_blank" rel="noreferrer">cookies</a> and <a href="https://policies.google.com/technologies/partner-sites" target="_blank" rel="noreferrer">Google tools</a> to analyze traffic and for ads measurement purposes.
            </div>
            <div className="flex-grow-0 ">
              <button className="btn cookie-btn" onClick={() => onAcceptClick()}>Accept</button>
            </div>
          </div>
        )
      }
    </>
  )
}